import { queryOptions, useQuery } from '@tanstack/react-query';

import type {
  GetMobileMenuTreeQueryVariables,
  GetBarMenuCategoriesQueryVariables,
  BarTypesQueryVariables
} from '@schema/cart';

import API from '@api';
import { withSsrCache } from '../../ssrCache';

/**
 * Дерево меню каталога и категории бар-меню — почти статичные данные.
 * Кэш на 10 минут решает проблему частых перезапросов из autorun в
 * CatalogBtn: autorun может срабатывать хоть на каждый опрос корзины,
 * но в сеть запрос уйдёт не чаще раза в 10 минут на каждый набор параметров.
 */
const CATALOG_MENU_STALE_TIME = 10 * 60 * 1000;
const CATALOG_MENU_GC_TIME = 15 * 60 * 1000;

export const mobileMenuTreeQueryOptions = (
  params: GetMobileMenuTreeQueryVariables = {}
) =>
  withSsrCache(
    queryOptions({
      queryKey: ['mobileMenuTree', params],
      queryFn: () => API.getMobileMenuTree(params),
      staleTime: CATALOG_MENU_STALE_TIME,
      gcTime: CATALOG_MENU_GC_TIME
    })
  );

export const barMenuCategoriesQueryOptions = (
  params: GetBarMenuCategoriesQueryVariables = {}
) =>
  withSsrCache(
    queryOptions({
      queryKey: ['barMenuCategories', params],
      queryFn: () => API.getBarMenuCategories(params),
      staleTime: CATALOG_MENU_STALE_TIME,
      gcTime: CATALOG_MENU_GC_TIME
    })
  );

export const barMenuTypesQueryOptions = (params: BarTypesQueryVariables = {}) =>
  queryOptions({
    queryKey: ['barMenuTypes', params],
    queryFn: () => API.getBarMenuTypes(params),
    // Стадии бар-меню (/categories, /categories/:type, /product/:id) —
    // отдельные роуты; кэш убирает перезапрос типов на каждом переходе
    select: res =>
      (res.getBarMenuTypes || []).filter(item => item?.active === 1),
    staleTime: CATALOG_MENU_STALE_TIME,
    gcTime: CATALOG_MENU_GC_TIME
  });

export const topMenuQueryOptions = () =>
  withSsrCache(
    queryOptions({
      queryKey: ['topMenu'],
      queryFn: () => API.getTopMenu(),
      staleTime: CATALOG_MENU_STALE_TIME,
      gcTime: CATALOG_MENU_GC_TIME
    })
  );

export const useTopMenuQuery = () => useQuery(topMenuQueryOptions());
